module.exports = {
  title: `SISOBUS PS BLOG`,
  description: `Problem Solving, Dev blog`,
  author: `sisobus`,
  introduction: `VUNO Inc. Software Engineer, Problem Solver`,
  siteUrl: `https://blog.sisobus.com`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `sisobus`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: `sisobus`, // Your Facebook account
  },
  icon: `content/assets/favicon.png`, // Add your favicon
  keywords: [`blog`, `problem solving`, `development`, `programming`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'sisobus/blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'sisobus',
  },
  share: {
    facebookAppId: '2244249489229176', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-134689927-1', // Add your google analytics tranking ID
}
